import * as React from "react";
import Button from './Button';

function CtaVideo() {
    return (
        <div className="grid grid-cols-12 w-full h-full relative py-14">
            <div className="col-span-12 text-center pb-12 px-8">
                <h2 className="font-semibold">Talk to the experts in expat financial advice</h2>
            </div>
            <div className="col-span-12 lg:col-start-3 lg:col-end-7 px-8 md:px-8 mr-10">
                <div style={{position: 'relative', paddingTop: '56.25%'}}>
                    <iframe
                        title="Expat Financial Advice Video"
                        src="https://customer-iclu53owqhlji7yh.cloudflarestream.com/d46e7aa4f5c0af010ae61536eaff205a/iframe?poster=https%3A%2F%2Fcustomer-iclu53owqhlji7yh.cloudflarestream.com%2Fd46e7aa4f5c0af010ae61536eaff205a%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D3s%26height%3D600"
                        loading="lazy"
                        style={{border: 'none', position: 'absolute', top: '0', left: '0', height: '100%', width: '100%'}}
                        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                        allowFullScreen={true}
                    />
                </div>
            </div>
            <div className="col-span-12 lg:col-start-7 lg:col-end-11 pt-8 lg:pt-0 px-8 lg:px-0">
                <h3 style={{paddingRight: '5%'}}>Rely on quality, independent advice with a service that you can trust.</h3>
                <ul style={{ listStyleType: 'disc', padding: '0', marginLeft: '20px', marginTop: '10px' }}>
                    <li style={{ marginBottom: '20px' }}>20,000+ clients in over 100 countries</li>
                    <li style={{ marginBottom: '20px' }}>Multi-award winning client services</li>
                    <li style={{ marginBottom: '20px' }}>Rated 'Excellent' by over 1,500 clients on Trustpilot</li>
                </ul>
                <div className="button-wrapper mt-10">
                    <Button color="holborn-greenBlue" href="/enquiry-form/">
                        Get financial advice
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default CtaVideo;